import React, { Component } from 'react';
import { PropTypes as MobxPropTypes } from 'mobx-react';
import { Row, Col } from 'react-bootstrap';
import { Form } from 'formsy-react-components';
import { withRouter } from "react-router-dom";
import { withCookies, Cookies } from 'react-cookie';
import { Heading, ContainerBox } from '../AdminStyle';
import { instanceOf } from 'prop-types';
import { LogeButtonSlim, LodgeButtonLoadingRing } from '../../GeneralStyle'
import MemberInputs from './Inputs/MemberInputs'
import Parse from 'parse'

export const requiredFields = ["companyId", "firstname", "lastname", "position", "gender", "email"]

class MemberForm extends Component {

	constructor(props) {
		super(props)
		this.state = {
			showAlert: false,

			memberImage: null,

			isLoading: false,
			loadingState: 0, // 0: Normal State, 1: Success, 2: Failure, 3: Successfully Created New
			buttonText: 'SPEICHERN',

			user: { ...this.props.user, companyId: this.props.user.company.objectId },

			error: null,
		}
		this.onSubmit = this.onSubmit.bind(this);
		this.handleAlertDismiss = this.handleAlertDismiss.bind(this);
	}

	componentDidUpdate(prevProps) {
		if (prevProps.user !== this.props.user)
			this.setState({ user: { ...this.props.user, companyId: this.props.user.company.objectId } })
	}

	// Reset button when form changes
	updateStates = () => {
		this.setState({
			isLoading: false,
			loadingState: 0, // 0: Normal State, 1: Success, 2: Failure
			buttonText: 'SPEICHERN',
		})
	}

	onSubmit = () => {
		this.setState({
			isLoading: true
		})

		const user = this.state.user;

		console.log("user", user);

		if(!user.handicap) user.handicap = 0

		// Setting new image identifier if new image has been added
		user.profileImage = (this.state.memberImage !== null ? this.state.memberImage : user.profileImage)

		//
		// If the user already has an objectId it is an existing one and updateUserById is executed
		//

		if (user.objectId) {
			Parse.Cloud.run('updateUserById', { "data": user })
				.then(result => {
					// Setting states for proper button rendering
					this.setState({
						isLoading: false,
						loadingState: 1,
						buttonText: 'GESPEICHERT'
					})
				})
				.catch(error => {
					// Setting states for proper button rendering
					this.setState({
						isLoading: false,
						loadingState: 2,
						buttonText: 'ERNEUT',
						error: error.message.message
					})
					console.error("error", error)
				})
			return
		}

		//
		// If the user does not have an objectId it is a new one and addUser is executed
		//

		Parse.Cloud.run("addUser", { data: user })
			.then(result => {
				// Setting states for proper button rendering
				this.setState({
					isLoading: false,
					loadingState: 3,
					buttonText: 'GESPEICHERT'
				})

				setTimeout(() => {
					this.props.history.push("/internal/admin/members")
				}, 1.5**1000);
			})
			.catch(error => {
				// Setting states for proper button rendering
				this.setState({
					isLoading: false,
					loadingState: 2,
					buttonText: 'ERNEUT',
					error: error.message.message
				})
				console.error("error", error)
			})

	}

	handleAlertDismiss() {
		this.setState({
			showAlert: false
		})
	}

	render() {
		const isButtonDisabled = () => {
			// Use HTML validation for now
			return false

			const user = this.state.user;

			for (let item of requiredFields) {
				if (user[item] === "" || user[item] == null) {
					return true
				}
			}

			// Check If Mail is Valid

			let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
			if (!re.test(String(user["email"]).toLowerCase()))
				return true

			return false
		}

		return (
			<div>
				<ContainerBox style={{maxWidth: 1200, margin: "20px auto"}}>
				{ this.state.user && this.state.user.role === null && 
					<Row style={{ display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
						<div style={{ background: 'red', color: 'white', textAlign: 'center', fontWeight: 'bold', display: 'inline-block', padding: '4px 8px' }}>Ungültige Nutzerrolle, Datenbankeingriff notwendig</div>
					</Row>
				}
					<Row style={{ paddingTop: 25, margin: 'auto' }}>
						<Heading style={{ paddingLeft: 0, marginLeft: 37 }}>
							{this.state.user.objectId
								? this.state.user.firstname + ' ' + this.state.user.lastname
								: "Neues Mitglied anlegen"}
						</Heading>
						<div style={{ paddingLeft: 0, marginLeft: 37, borderBottom: "1px solid rgb(33,45,61,15%)", width: "25%", marginBottom: 20 }}></div>

						<Form
							className={'dashboard-form'}
							onSubmit={this.onSubmit}
							onChange={this.updateStates}
							layout={'vertical'}
							validatePristine={true}
							disabled={this.state.loadingState === 3}
						>

							<MemberInputs onChange={(state) => this.setState(state) } data={this.state.user} requiredFields={requiredFields}/>

							<Col md={12} className="text-center" style={{ paddingBottom: 45, display: 'flex', justifyContent: 'center' }}>
								<p style={{
									position: 'absolute',
									display: 'block',
									left: 0,
									right: 0,
									top: 14,
									/* Conditional rendering of text according to loadingState */
									transform: this.state.loadingState !== 0 && this.state.loadingState !== 3 ? 'translateY(50px)' : this.state.loadingState === 3 ? 'translateY(100px)' : 'none',
									color: this.state.loadingState === 2 ? 'rgb(217, 83, 79)' : '#DAB777',
								}}>
									{this.state.loadingState === 0 ? "" : (this.state.loadingState === 1 || this.state.loadingState === 3 ? 'Erfolgreich gespeichert' : this.state.error)}
								</p>

								{ this.state.loadingState !== 3 && <div>
								<LodgeButtonLoadingRing style={{ transform: this.state.isLoading ? 'translateX(90px)' : 'none' }}></LodgeButtonLoadingRing>
								<LogeButtonSlim
									style={{
										position: 'relative',
										display: 'flex',
										margin: 'auto !important',
										alignItems: 'center',
										justifyContent: 'center',
										background: '#FFF'
									}}
									disabled={ isButtonDisabled() }
									hoverFontColor={"white"}
									// Conditional rendering of button according to loadingState
									{...(this.state.loadingState === 2 ? { color: 'rgb(217, 83, 79)', fontColor: 'rgb(217, 83, 79)' } : {})}
								>
									{this.state.buttonText}
								</LogeButtonSlim>
								</div>}
							</Col>
						</Form>
						{ ( this.state.loadingState === 1 || this.state.loadingState === 3 ) &&
							<Col md={12} className="text-center" style={{ paddingBottom: 75, display: 'flex', justifyContent: 'center' }}>
								<LogeButtonSlim
									style={{
										position: 'relative',
										display: 'flex',
										margin: 'auto !important',
										alignItems: 'center',
										justifyContent: 'center',
										background: '#FFF'
									}}
									hoverFontColor={"white"}
									onClick={() => this.props.history.push("/internal/admin/members")}
								>
									zurück zur Liste
								</LogeButtonSlim>
							</Col>
						}

					</Row>
				</ContainerBox>
			</div>
		);
	}
}

MemberForm.propTypes = {
	userStore: MobxPropTypes.observableObject,
	cookies: instanceOf(Cookies).isRequired
};

export default withCookies(withRouter(MemberForm));



// WEBPACK FOOTER //
// /src/components/admin/Forms/MemberForm.js